import { RecordHoldbackDrawDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateRecordHoldbackDrawDisbursement = makeValidator({
  FieldParser: RecordHoldbackDrawDisbursementRow,
});
